import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

export const StyledFinishStack = styled(Stack)({
  gridColumn: "span 3",
  display: "grid",
  gridTemplateRows: "repeat(5, 18px)",
  gridAutoFlow: "column",
  gridAutoColumns: "auto",
  gridRow: "span 5",
  rowGap: "2px",
  columnGap: "10px",
});

export const NotesStack = styled(Stack, {
  shouldForwardProp: (prop) => !["col", "row"].includes(prop),
})(({ col = 3, row = 2, theme }) => ({
  gridColumn: `span ${col}`,
  gridRow: `span ${row}`,
  padding: "2px",
  backgroundColor: theme.palette.hubColors.mainFocusLighter2,
  "& .WorkOrderLabel-root": {
    textWrap: "initial",
  },
}));

export const StyledBaseBox = styled(Stack, {
  shouldForwardProp: (prop) =>
    !["columns", "disableBorder", "rows", "disablePadding"].includes(prop),
})(
  ({
    columns = 3,
    disableBorder = false,
    rows,
    disablePadding = false,
    customColumns = "",
  }) => ({
    display: "grid",
    gridTemplateColumns: customColumns
      ? customColumns
      : `repeat(${columns}, 1fr)`,
    columnGap: "10px",
    rowGap: "3px",
    ...(!disablePadding ? { padding: "10px" } : {}),
    ...(!disableBorder ? { borderBottom: "1px dashed" } : {}),
    ...(rows ? { gridTemplateRows: `repeat(${rows}), 1fr` } : {}),
  })
);

export const StyledWaxBox = styled(Stack, {
  shouldForwardProp: (prop) =>
    !["columns", "disableBorder", "disablePadding"].includes(prop),
})(({ columns = 3, disableBorder = false, disablePadding }) => ({
  display: "grid",
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  gap: "25px",
  ...(!disableBorder ? { borderBottom: "1px dashed" } : {}),
  ...(!disablePadding ? { padding: "10px" } : {}),
}));

export const StyledMeltStack = styled(Stack)({
  padding: "10px",
  borderBottom: "1px dashed",
  gap: "15px",
});

export const StyledMeltBox = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  alignItems: "center",
  gap: "15px",
  rowGap: "5px",
});

export const StyledMeltBoxMetals = styled(Stack)({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: "15px",
  rowGap: "5px",
});

export const StyledWaxStack = styled(Stack)({
  gap: "10px",
});

export const StyledLabelStack = styled(Stack, {
  shouldForwardProp: (prop) => !["c1"].includes(prop),
})(({ c1 = "100px" }) => ({
  display: "grid",
  gridTemplateColumns: `${c1} 1fr`,
  gap: "5px",
}));
